import { queryOptions, skipToken } from '@tanstack/react-query';
import { configuration } from '../../configuration';
import axiosInstance, { bypassCacheConfig } from '../../utils/axiosInstance';
import { toApiError } from '../../utils/httpError';

const msr2EmbedQueryKeys = {
  addTitle: (workspaceId?: string) =>
    [...msr2EmbedQueryKeys.all, 'add-title', { workspaceId }] as const,
  all: ['msr2-embed'] as const,
};

const fetchMsr2AddTitleAvailability = async (
  workspaceId: string,
): Promise<boolean> => {
  try {
    const response = await axiosInstance.get<{ available: boolean }>(
      `${configuration.WORKSPACES_API_BASE}/workspace/${workspaceId}/msr2-embed/add-title-available`,
      bypassCacheConfig(),
    );

    return response.data.available;
  } catch (error) {
    throw toApiError(error, {
      endpoint: 'workspace/:id/msr2-embed/add-title-available',
      params: { workspaceId },
    });
  }
};

export const queryOptionsMsr2AddTitleAvailable = (workspaceId?: string) =>
  queryOptions({
    queryFn: workspaceId
      ? () => fetchMsr2AddTitleAvailability(workspaceId)
      : skipToken,
    queryKey: msr2EmbedQueryKeys.addTitle(workspaceId),
  });
